import { Theme } from "../../../../components/constants";

export default {
    createFormContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        // height: 'calc(100% - 56px)',
        justifyContent:'space-between',
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    headerRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    stepperRow: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginTop: "10px",
    },
    selectedFormInfo: {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
    },
    formSubId: {
        fontWeight: 400,
        color: Theme.DISABLED_TEXT,
        marginLeft: "10px",
    },
    previewOptionDiv: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    previewFormText: {
        fontWeight: 700,
        lineHeight: "19px",
        color: Theme.PRIMARY,
        marginRight: "30px",
    },
    irsViewSwitch: {
        marginRight: "8px",
        display: "flex",
    },
    irsViewText: {
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    helpTextPopupStypes: {
        width: "80%", 
        maxWidth: "80%", 
        height: "80%"
    },
    helpTextPopupHeaderStyles: {
        border: "1px solid #ccc",
        padding: "5px 10px"
    },
    helpTextChildrenStyles: {
        padding: "20px",
        height: "100%",
    }
}